import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import {
  SmoothColorChange,
  SmoothPolygonChange,
} from '@pyg-animations/products';
import { Item, itemsData } from './item';
import { TranslatePipe } from '@ngx-translate/core';
import { ProductDescriptionComponent } from './product-description/product-description.component';
import { LangRouterLink } from '@pyg-directives/lang-router-link.directive';

@Component({
  selector: 'app-product-schema',
  templateUrl: './product-schema.component.html',
  styleUrls: ['./product-schema.component.scss'],
  animations: [SmoothColorChange, SmoothPolygonChange],
  imports: [TranslatePipe, ProductDescriptionComponent, LangRouterLink],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductSchemaComponent {
  public readonly items: Item[] = itemsData;
  public readonly activeState = signal<number>(0);
  public readonly toogleDescription = signal<boolean>(true);

  setStateAsActive(itemEl: number, withToogle: boolean = false) {
    if (this.activeState() !== itemEl) {
      this.activeState.set(itemEl);
      this.toogleDescription.set(true);
    } else if (withToogle) {
      this.toogleDescription.set(!this.toogleDescription());
    }
  }
}
